module.exports = __webpack_public_path__ + "static/media/agendaEvent.159f7925.png";